import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { analytics } from "../utils/analytics";

import styles from "./OrderConfirmation.module.css";

const OrderConfirmation = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const orderNumber = state?.orderNumber; // Отримуємо номер замовлення з переданого стану

  const [isLoading, setIsLoading] = useState(true);
  const [redirectCountdown, setRedirectCountdown] = useState(1); // Таймер на 1 секунду

  // ✅ Аналітика — фіксуємо завершення покупки
  useEffect(() => {
    if (orderNumber) {
      analytics.purchaseCompleted({
        orderNumber,
        totalPrice: state?.totalAmount || 0,
        cartItems: state?.cartItems || [],
        paymentMethod: state?.customerDetails?.paymentMethod || "Невідомо",
      });
    }
  }, [orderNumber, state]);

  console.log("📦 Отриманий orderNumber у OrderConfirmation:", orderNumber);

  console.log("🆕 OrderConfirmation компонент змонтовано.");
  console.log("📦 Початковий стан orderNumber:", orderNumber);
  console.log("⏳ Початковий стан isLoading:", isLoading);
  console.log("⏱️ Початковий стан redirectCountdown:", redirectCountdown);
  console.log("📦 Переданий state у OrderConfirmation:", state);
  console.log("📝 Отриманий orderNumber у OrderConfirmation:", orderNumber);

  useEffect(() => {
    console.log("⏳ Виконання useEffect...");

    // Імітуємо коротку затримку перед показом даних (для зручності користувача)
    console.log("⏰ Запуск таймера завантаження на 1 секунду...");
    const loadTimer = setTimeout(() => {
      console.log("✅ Завантаження завершено, встановлюємо isLoading = false");
      setIsLoading(false);
    }, 1000);

    // Таймер для автоматичного повернення на головну
    let redirectTimer;

    if (!isLoading && orderNumber) {
      console.log("🚀 Запуск таймера перенаправлення на головну сторінку...");
      redirectTimer = setInterval(() => {
        setRedirectCountdown((prev) => {
          console.log(`⏱️ Залишилось ${prev - 1} секунд до перенаправлення...`);
          if (prev <= 1) {
            console.log("🔙 Перенаправлення на головну сторінку...");
            navigate("/"); // Повернення на головну
            clearInterval(redirectTimer);
          }
          return prev - 1;
        });
      }, 10000);
    }

    // Функція очищення, щоб зупинити таймери при зміні залежностей або розмонтуванні компонента
    return () => {
      console.log("🧹 Очищення таймерів...");
      clearTimeout(loadTimer);
      clearInterval(redirectTimer); // Очищаємо таймер redirectTimer
    };
  }, [isLoading, orderNumber, navigate]); // Додаємо залежності isLoading, orderNumber, navigate

  if (!orderNumber && !isLoading) {
    console.warn(
      "⚠️ orderNumber відсутній, показуємо повідомлення про помилку."
    );
    return (
      <div className={styles.orderConfirmation}>
        <h1>Неможливо знайти ваше замовлення</h1>
        <p>
          Будь ласка, перевірте правильність даних або оформіть нове замовлення.
        </p>
        <button
          onClick={() => {
            console.log(
              "🔙 Перенаправлення на головну сторінку після помилки..."
            );
            navigate("/");
          }}
          className={styles.returnHomeButton}
        >
          Повернутися на головну сторінку
        </button>
      </div>
    );
  }

  if (isLoading) {
    console.log("⏳ Завантаження інформації про замовлення...");
    return (
      <div className={styles.orderConfirmation}>
        <h1>Завантаження інформації про замовлення...</h1>
        <p>Будь ласка, зачекайте.</p>
      </div>
    );
  }

  console.log("✅ Замовлення успішно створено, показуємо підтвердження.");

  return (
    <div className={styles.orderConfirmation}>
      <h1>Дякуємо за ваше замовлення!</h1>
      <p>
        Замовлення №{orderNumber} успішно створено та знаходиться в обробці.
      </p>
      <p>Очікуйте СМС-повідомлення про підтвердження замовлення!</p>
      <button
        onClick={() => {
          console.log(
            "🔙 Кнопка перенаправлення на головну сторінку натиснута."
          );
          navigate("/");
        }}
        className={styles.returnHomeButton}
      >
        Повернутися на головну сторінку
      </button>
    </div>
  );
};

export default OrderConfirmation;
